import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Input from "../Input";
import ModalSkeleton from "../ModalSkeleton/ModalSkeleton";
import TextArea from "../TextArea";
import classes from "./LastStepModal.module.css";
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";

import PublicIcon from "@mui/icons-material/Public";
import Button from "../Button/Button";
import { toast } from "react-toastify";
import {
  apiHeader,
  BaseURL,
  formRegEx,
  formRegExReplacer,
  validateEmail,
} from "../../config/apiUrl";
import { Post } from "../../Axios/AxiosFunctions";
import { saveLoginUserData } from "../../redux/auth/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const LastStepModal = ({ show, setShow, formData }) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // handleSubmit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      fullName: fullName,
      email: email,
      location: location,
      userDescription: description,
      role: "customer",
    };
    for (var key in data) {
      if (data[key] == "")
        return toast.warn(
          `${key.replace(formRegEx, formRegExReplacer).trim()} cannot be empty`
        );
    }

    // validate Email
    if (!validateEmail(email)) {
      return toast.warn("Please enter a valid email address");
    }

    for (let key in data) {
      formData.append(key, data[key]);
    }

    setLoader(true);
    const response = await Post(
      BaseURL("users/create-card/signup"),
      formData,
      apiHeader(false, true)
    );
    setLoader(false);
    if (response != undefined) {
      dispatch(saveLoginUserData(response?.data));
      navigate("/my-cards");
    }else{
      formData.delete('fullName')
      formData.delete('email')
      formData.delete('location')
      formData.delete('userDescription')
      formData.delete('role')
    }
  };

  return (
    <ModalSkeleton show={show} setShow={setShow}>
      <Container>
        <form onSubmit={handleSubmit} autoComplete={false}>
          <Row className={classes.input_mar}>
            <div className={"text-center"}>
              <h3>Last Step</h3>
              <p style={{ color: "#929292" }}>Please enter your detail here.</p>
            </div>
            <Col md={12}>
              <label>Your Name</label>
              <Input
                className={classes.cus_input}
                leftIcon={<PersonIcon />}
                placeholder={"John Denly"}
                setter={setFullName}
                value={fullName}
              />
            </Col>

            <Col md={6}>
              <label>Email</label>
              <Input
                className={classes.cus_input}
                leftIcon={<MailIcon />}
                placeholder={"johndenly@info.com"}
                setter={setEmail}
                value={email}
              />
            </Col>
            <Col md={6}>
              <label>Location</label>
              <Input
                className={classes.cus_input}
                leftIcon={<PublicIcon />}
                placeholder={"Carribean"}
                setter={setLocation}
                value={location}
              />
            </Col>

            <Col md={12}>
              <label>Description</label>
              <TextArea
                value={description}
                setter={setDescription}
                className={classes.textAreaStyle}
                placeholder={"Tell us about your..."}
              />
            </Col>
            <div className={classes.lgn_btn_div}>
              <Button disabled={loader} type={"submit"} primary>
                {loader ? "Please Wait..." : "Signup"}
              </Button>
            </div>
          </Row>
        </form>
      </Container>
    </ModalSkeleton>
  );
};

export default LastStepModal;
